export const convertDataNameToNiceName = (name) => {
  let match = name?.match(/^\d+\s*-\s*/)

  if (match) {
    return name.substring(match[0].length)
  }

  return name
}
